// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { ContextFlag, ContextFlagArr } from "../schema";
import { serialize_ContextFlag_internal, deserialize_ContextFlag_internal } from "./ContextFlag";

export function serialize_ContextFlagArr_internal(value: ContextFlagArr): unknown {
  return ((value: { items: ContextFlag[] }): unknown => {
    return {
      items: ((value: ContextFlag[]): unknown => {
        return value.map((value: ContextFlag): unknown => {
          return serialize_ContextFlag_internal(value);
        });
      })(value["items"]),
    };
  })(value);
}
export function serialize_ContextFlagArr(obj: ContextFlagArr): string {
  return renderJsonWithNumbersAsBigint(serialize_ContextFlagArr_internal(obj));
}
export function deserialize_ContextFlagArr_internal(value: unknown): ParserResult<ContextFlagArr> {
  return ((
    value: unknown,
  ): ParserResult<{
    items: ContextFlag[];
  }> => {
    if (typeof value !== "object") {
      return { success: false, reason: `[#/components/schemas/ContextFlagArr]: '${value}' expected to be of type 'object'.` };
    }
    if (value === null) {
      return { success: false, reason: `[#/components/schemas/ContextFlagArr]: '${value}' expected to not be null.` };
    }
    if (!hasProp(value, "items")) {
      return { success: false, reason: `[#/components/schemas/ContextFlagArr/items]: '${renderJsonWithNumbersAsBigint(value)}' expected to have property 'items'.` };
    }
    const parsed_items = ((): ParserResult<ContextFlag[]> => {
      return ((value: unknown): ParserResult<ContextFlag[]> => {
        if (!isArray(value)) {
          return { success: false, reason: `[#/components/schemas/ContextFlagArr/items]: '${value}' expected to be an array.` };
        }
        const parsed = value.map((value: unknown): ParserResult<ContextFlag> => {
          return deserialize_ContextFlag_internal(value);
        });
        if (parsed.find((value) => !value.success) !== undefined) {
          return {
            success: false,
            reason: `[#/components/schemas/ContextFlagArr/items]: Reason(s): '${parsed
              .filter((p) => !p.success)
              .map((p) => p.reason)
              .join(", ")}'.`,
          };
        }
        return {
          success: true,
          value: parsed.map((entry) => {
            assert(entry.success == true);
            return entry.value;
          }),
        };
      })(value["items"]);
    })();
    if (!parsed_items.success) {
      return { success: false, reason: parsed_items.reason };
    }
    return { success: true, value: { items: parsed_items.value } };
  })(value);
}
export function deserialize_ContextFlagArr(str: string): ParserResult<ContextFlagArr> {
  return deserialize_ContextFlagArr_internal(parseJsonWithNumbersAsBigint(str));
}
